const host = window.location.host;

if (!/(?:localhost|(?:\d{1,3}\.){3}\d{1,3})/i.test(host)) {
    let PROD_KEY = 'AD-AAB-ABM-FTP';
    let TEST_KEY = 'AD-AAB-ABM-FTR';
    let APP_BASE_PATH = window.location.pathname.indexOf('/profile/delivery-management') !== -1
        ? '/profile/delivery-management'
        : '/profile-delivery-manager';
    let ADRUM_PATH = APP_BASE_PATH + '/assets/adrum/adrum.js';

    // adrum.js loads adrum-ext.<hash>.js itself via a <script src> tag, which
    // BYPASSES the single-bundle fetch/XHR interceptors. Inside the Polaris shell,
    // window.location.host is the SHELL host, which does not serve the MFE's
    // /assets/adrum path, so the ext agent would 404. window['__mfeAssetBase'] is
    // set by the single bundle to the MFE's real deploy origin+base; use it for the
    // ext base (a <script src> loads cross-origin fine) and fall back to the page
    // origin for standalone dotcom, where the page origin already hosts the assets.
    let ADRUM_EXT_BASE = (window['__mfeAssetBase'] || (window.location.origin + APP_BASE_PATH)) + '/assets/adrum';

    try {
        window['adrum-start-time'] = new Date().getTime();
        (function (config) {
            config.appKey = (/(?:www|my)\.fedex\.com/i).test(host) ? PROD_KEY : TEST_KEY;
            config.angular = true;
            config.adrumExtUrlHttps = ADRUM_EXT_BASE;
            config.adrumExtUrlHttp = ADRUM_EXT_BASE;
            config.beaconUrlHttp = 'http://pdx-col.eum-appdynamics.com';
            config.beaconUrlHttps = 'https://pdx-col.eum-appdynamics.com';
            config.enableSpeedIndex = true;
            config.isZonePromise = true;
            config.longStackTrace = false;
            config.maxUrlLength = 512;
            config.resTiming = {"bufSize":200,"clearResTimingOnBeaconSend":true};
            config.spa = {'spa2': true};
            config.useHTTPSAlways = true;
            config.xd = {enable: false};
        })(window['adrum-config'] || (window['adrum-config'] = {}));
        fetch('https://' + host + ADRUM_PATH)
            .then(function(response) { return response.text(); })
            .then(function(text) {
                var blob = new Blob([text], { type: 'text/javascript' });
                var blobUrl = URL.createObjectURL(blob);
                var adrumScript = document.createElement('script');
                adrumScript.onload = function() { URL.revokeObjectURL(blobUrl); };
                adrumScript.src = blobUrl;
                var target = document.body || document.head || document.documentElement;
                if (target) {
                    target.appendChild(adrumScript);
                }
            })
            .catch(function(error) {
                (console.error || console.log).call(console, error.stack || error);
            });
    } catch (error) {
        (console.error || console.log).call(console, error.stack || error);
    }
}
